module.exports = __webpack_public_path__ + "static/media/bottom_banner_6_1.e85d091e.png";